import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../../Components';
import AutoPigModel from '../../../../Components/AutoPig/autoPigModel';
import BasicData from '../../../../Components/AutoPig/basicData';
// import { SystemData } from '../../../../Assets/TestData/systems';
import { frames } from '../../../../Styles'

export default function AutoPig() {
  const {t} = useTranslation()

  // Get System Name for Header
  // const { systemName } = useMemo(() => {
  //   const systemData = SystemData.find((system) => system.systemId === 1);
  //   return {
  //     systemName: systemData?.systemName || "",
  //   };
  // }, []);

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <PageHeader topHeader={"systemName"} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})}/>
      </frames._page_inner_header>
      
      <frames._page_inner_content>
        <div style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "50px"}}>
          <AutoPigModel/>
          <BasicData/>
        </div>
      </frames._page_inner_content>
    </frames.Page_inner>
  );
}